// src/components/YourPath/RutasDidacticasEditStep2.js
import React, { useState, useEffect, useCallback } from "react";
import { Loader, Image, Checkbox, Button, Icon } from "semantic-ui-react";
import { AssistanceApi, DidacticRoutesAPI } from "../../../../api";
import { useAuth } from "../../../../hooks";

// Importamos el SCSS que crearemos a continuación
import "./RutasDidacticasEditStep2.scss";

const assistanceApi = new AssistanceApi();
const didacticRoutesAPI = new DidacticRoutesAPI();

// ID fijo de Educa360
const EDUCA360_USER_ID = "67921ab3740e0f2aba258111";

export function RutasDidacticasEditStep2({
  route,
  accessToken,
  onRefresh,
  onClose,
  onBack,
}) {
  const { user } = useAuth(); // user.user._id
  const [loading, setLoading] = useState(false);
  const [assistants, setAssistants] = useState([]);
  const [selectedAssistants, setSelectedAssistants] = useState([]);
  const [viewMode, setViewMode] = useState("edu360"); // "edu360" o "mine"

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await assistanceApi.getAssistances(accessToken, 1, 100);
      let docs = response?.assistances?.docs || [];

      // Filtrar según modo
      if (viewMode === "edu360") {
        docs = docs.filter((a) => a.user === EDUCA360_USER_ID);
      } else {
        docs = docs.filter((a) => a.user === user.user._id);
      }

      setAssistants(docs);

      // IDs que ya tiene la ruta
      const assignedIds = (route.assistants || []).map((a) => a.assistant);
      setSelectedAssistants(assignedIds);
    } catch (error) {
      console.error("Error al cargar asistentes:", error);
    } finally {
      setLoading(false);
    }
  }, [accessToken, route.assistants, viewMode, user.user._id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleToggleAssistant = (assistantId) => {
    setSelectedAssistants((prev) =>
      prev.includes(assistantId)
        ? prev.filter((id) => id !== assistantId)
        : [...prev, assistantId]
    );
  };

  const handleSaveAll = async () => {
    setLoading(true);
    try {
      // Actualizar ruta
      await didacticRoutesAPI.updateDidacticRoute(accessToken, route._id, {
        nameRute: route.nameRute,
        description: route.description,
        classnumber: route.classnumber,
      });
      // Actualizar asistentes
      await didacticRoutesAPI.insertAssistantsInRoute(
        accessToken,
        route._id,
        selectedAssistants
      );
      onRefresh?.();
      onClose();
    } catch (error) {
      console.error("Error al actualizar el itinerario:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewEdu360 = () => setViewMode("edu360");
  const handleViewMine = () => setViewMode("mine");

  return (
    <div className="rutas-step2">
      <h3 className="rutas-step2__title">
        Activar Asistentes IA del Itinerario
      </h3>

      <div className="rutas-step2__filter-buttons">
        <Button
          onClick={handleViewEdu360}
          color={viewMode === "edu360" ? "blue" : undefined}
          className="rutas-step2__filter-btn"
        >
          Educa360
        </Button>
        <Button
          onClick={handleViewMine}
          color={viewMode === "mine" ? "grey" : undefined}
          className="rutas-step2__filter-btn"
        >
          Propios
        </Button>
      </div>

      {loading ? (
        <div className="rutas-step2__loader-wrapper">
          <Loader active inline="centered" size="large" />
        </div>
      ) : (
        <div className="rutas-step2__assistants-list">
          {assistants.map((assistant) => {
            const isChecked = selectedAssistants.includes(assistant._id);
            return (
              <div
                key={assistant._id}
                className="rutas-step2__assistant-row"
              >
                <Image
                  src={assistant.miniature}
                  size="tiny"
                  circular
                  className="rutas-step2__assistant-img"
                />
                <div className="rutas-step2__assistant-info">
                  <strong className="rutas-step2__assistant-title">
                    {assistant.title}
                  </strong>
                </div>
                <Checkbox
                  toggle
                  checked={isChecked}
                  onChange={() => handleToggleAssistant(assistant._id)}
                  className="rutas-step2__assistant-checkbox"
                />
              </div>
            );
          })}
        </div>
      )}

      <div className="rutas-step2__buttons">
        <Button onClick={onBack} color="grey" className="rutas-step2__btn">
          Volver
        </Button>
        <Button
          
          onClick={handleSaveAll}
          loading={loading}
          //disabled={selectedAssistants.length === 0}
          className="rutas-step2__btn"
        >
          <Icon name="save" />
          Guardar todo
        </Button>
        <Button
          onClick={onClose}
          disabled={loading}
          className="rutas-step2__btn"
        >
          Cancelar
        </Button>
      </div>
    </div>
  );
}
